import { useMemo } from 'react'
import InsightViewOption, { InsightViewOptionStrings } from 'enums/InsightViewOption'
import { generateCvLogosStrategy } from 'utils/insightModal/strategy/widgetSettingComposing'

const useWidgetSettingComposingStrategy = (viewOption: InsightViewOptionStrings) => {
  const widgetSettingComposingStrategy = useMemo(() => {
    switch (viewOption) {
      case InsightViewOption.LOGOS:
        return generateCvLogosStrategy()
      case InsightViewOption.DETECT_OBJECTS:
      case InsightViewOption.DETECT_SCENES:
      case InsightViewOption.DETECT_EMOTIONS:
        return undefined
      default:
        throw new Error(`Unsupported view option: ${viewOption}`)
    }
  }, [viewOption])

  return widgetSettingComposingStrategy
}

export default useWidgetSettingComposingStrategy
